<template>
  <div id="home" style="height: auto">
    <OilTypeCard />

    <div class="vx-row">
      <div class="flex-1 mx-1">
        <v-date-picker
          v-if="$i18n.locale == 'th'"
          :buddhist="true"
          class="cursor-pointer"
          mode="range"
          v-model="selectedDate"
          :locale="$i18n.locale"
          :max-date="new Date()"
          :popover="{ placement: 'bottom-start', visibility: 'click' }"
        >
          <vs-card class="text-center cardDate">
            <div class="vx-row">
              <div
                class="vx-col text-center mt-2 pl-5 sm:w-1/3 lg:w-1/3 xl:w-1/3"
              >
                <vs-icon size="medium" icon="today"></vs-icon>
              </div>
              <div class="vx-col center sm:w-2/3 lg:w-2/3 xl:w-2/3">
                <h6>{{ setFormat(selectedDate.start) }}</h6>
                <hr class="mx-2 my-1" />
                <h6>{{ setFormat(selectedDate.end) }}</h6>
              </div>
            </div>
          </vs-card>
        </v-date-picker>
        <v-date-picker
          v-else
          :buddhist="false"
          class="cursor-pointer"
          mode="range"
          v-model="selectedDate"
          :locale="$i18n.locale"
          :max-date="new Date()"
          :popover="{ placement: 'bottom-start', visibility: 'click' }"
        >
          <vs-card class="text-center cardDate">
            <div class="vx-row">
              <div
                class="vx-col text-center mt-2 pl-5 sm:w-1/3 lg:w-1/3 xl:w-1/3"
              >
                <vs-icon size="medium" icon="today"></vs-icon>
              </div>
              <div class="vx-col center sm:w-2/3 lg:w-2/3 xl:w-2/3">
                <h6>{{ setFormat(selectedDate.start) }}</h6>
                <hr class="mx-2 my-1" />
                <h6>{{ setFormat(selectedDate.end) }}</h6>
              </div>
            </div>
          </vs-card>
        </v-date-picker>
      </div>
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.ALL"
        :name="$t('totalOil')"
        :isActive="isAllCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume()"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.IRPC"
        :refineryID="REFINERY_ID.IRPC"
        :name="$t('RefineryIRPC')"
        :isActive="isIrpcCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.IRPC)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.SPRC"
        :refineryID="REFINERY_ID.SPRC"
        :name="$t('RefinerySPRC')"
        :isActive="isSprcCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.SPRC)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.TOP"
        :refineryID="REFINERY_ID.TOP"
        :name="$t('RefineryTOP')"
        :isActive="isTopCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.TOP)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.BCP"
        :refineryID="REFINERY_ID.BCP"
        :name="$t('RefineryBCP')"
        :isActive="isBcpCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.BCP)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.PTTGC"
        :refineryID="REFINERY_ID.PTTGC"
        :name="$t('RefineryPTTGC')"
        :isActive="isPttgcCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.PTTGC)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.ESSO"
        :refineryID="REFINERY_ID.ESSO"
        :name="$t('RefineryESSO')"
        :isActive="isEssoCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.ESSO)"
        :isLoading="isVesselTripLoading"
      />
    </div>

    <div class="vx-row">
      <div class="vx-col w-full sm:w-3/5 lg:w-3/5 xl:w-3/5">
        <vx-card class="w-full">
          <DirectTree :startDate="config.startDate" :endDate="config.endDate" />
          <bar-value
            id="barChartdiv"
            :data="[
              `${this.getVolume(currentRefName)}`,
              `${formatNumber(
                Number(
                  getStationValues(currentRefID) * lastOilPrice.price
                ).toFixed(2)
              )}`,
              `${formatNumber(
                Number(getStationValues(currentRefID) * 6.44).toFixed(2)
              )}`,
              `${formatNumber(
                Number(
                  getStationValues(currentRefID) * lastOilPrice.price * 0.01
                ).toFixed(2)
              )}`,
            ]"
          />
          <vs-button
            color="dark"
            type="flat"
            class="fullScreenButton px-4 py-3"
            @click="popupDirectTree = true"
          >
            <vs-icon icon="crop_free"></vs-icon>
          </vs-button>
        </vx-card>
        <vs-popup fullscreen title :active.sync="popupDirectTree">
          <vx-card class="vx-col w-full" style="height: 100%">
            <DirectTree
              :startDate="config.startDate"
              :endDate="config.endDate"
              style="height: 500px"
            />
            <bar-value
              id="barChartdiv"
              :data="[
                `${this.getVolume(currentRefName)}`,
                `${formatNumber(
                  Number(
                    getStationValues(currentRefID) * lastOilPrice.price
                  ).toFixed(2)
                )}`,
                `${formatNumber(
                  Number(getStationValues(currentRefID) * 6.44).toFixed(2)
                )}`,
                `${formatNumber(
                  Number(
                    getStationValues(currentRefID) * lastOilPrice.price * 0.01
                  ).toFixed(2)
                )}`,
              ]"
            />
          </vx-card>
        </vs-popup>
      </div>
      <div class="vx-col w-full sm:w-2/5 lg:w-2/5 xl:w-2/5">
        <div class="w-full app-fixed-height" style="height: 420px">
          <Map :date="config" />
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full sm:w-3/5 lg:w-3/5 xl:w-3/5">
        <vx-card class="mt-2 h-full">
          <vs-button
            color="dark"
            type="flat"
            class="fullScreenButton px-4 py-3"
            @click="popupChart = true"
          >
            <vs-icon icon="crop_free"></vs-icon>
          </vs-button>
          <h5 class="text-center">{{ $t("Graphics") }}</h5>
          <vs-tabs alignment="fixed">
            <vs-tab :label="$t('No') + ' 1'">
              <RadarBar />
            </vs-tab>
            <vs-tab :label="$t('No') + ' 2'">
              <SunBurst />
            </vs-tab>
            <vs-tab :label="$t('No') + ' 3'">
              <StackedColumnChart
                :dataStack="vesselTrip"
                style="height: 400px"
              />
            </vs-tab>
            <vs-tab  v-if="typeTanker == TANKER_TYPE.TRANSFER" :label="$t('No')+' 4'">
              <HighlightingChartTransfer />
            </vs-tab>
            <vs-tab  v-else :label="$t('No')+' 4'">
              <HighlightingChart :dataLine="vesselTrip" />
            </vs-tab>
          </vs-tabs>
        </vx-card>
        <vs-popup fullscreen title :active.sync="popupChart">
          <vx-card class="mt-2">
            <h5 class="text-center">{{ $t("Graphics") }}</h5>
            <vs-tabs alignment="fixed">
              <vs-tab :label="$t('No') + ' 1'">
                <RadarBar style="height: 480px" />
              </vs-tab>
              <vs-tab :label="$t('No') + ' 2'">
                <SunBurst style="height: 530px" />
              </vs-tab>
              <vs-tab :label="$t('No') + ' 3'">
                <StackedColumnChart
                  :dataStack="vesselTrip"
                  style="height: 480px"
                />
              </vs-tab>
              <vs-tab :label="$t('No') + ' 4'">
                <HighlightingChart
                  :dataLine="vesselTrip"
                  style="height: 480px"
                />
              </vs-tab>
            </vs-tabs>
          </vx-card>
        </vs-popup>
      </div>

      <div class="vx-col w-full sm:w-2/5 lg:w-2/5 xl:w-2/5">
        <vx-card class="mt-2 h-full">
          <vs-button
            color="dark"
            type="flat"
            class="fullScreenButton px-4 py-3"
            @click="popupTable = true"
          >
            <vs-icon icon="crop_free"></vs-icon>
          </vs-button>

          <div v-if="typeTanker == TANKER_TYPE.TRANSFER">
            <TransferTable />
          </div>
          <div v-else-if="typeTanker == TANKER_TYPE.TANKER">
            <TankerTable />
          </div>
          <div v-else-if="typeTanker == TANKER_TYPE.VESSEL">
            <VesselTable />
          </div>
          <div v-else>
            <RefineryTable />
          </div>
        </vx-card>
        <vs-popup fullscreen class="holamundo" title :active.sync="popupTable">
          <vx-card class="mt-2" style="height: 50%">
            <div v-if="typeTanker == TANKER_TYPE.TRANSFER">
              <TransferTable />
            </div>
            <div v-else-if="typeTanker == TANKER_TYPE.TANKER">
              <TankerTable />
            </div>
            <div v-else-if="typeTanker == TANKER_TYPE.VESSEL">
              <VesselTable />
            </div>
            <div v-else>
              <RefineryTable />
            </div>
          </vx-card>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import OilTypeCard from "@/components/Card/OilTypeCard.vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Map from "@/components/map/Map.vue";
import StackedColumnChart from "@/components/Charts/StackedColumnChart.vue";
import BarValue from "@/common/BarValue.vue";
import HighlightingChart from "@/components/Charts/HighlightingChart.vue";
import HighlightingChartTransfer from "@/components/Charts/GreenOil/HighlightingChartTransfer.vue";
import RadarBar from "@/components/Charts/RadarChart.vue";
import TransferTable from "@/components/Table/GreenOil/TransferTable.vue";
import VesselTable from "@/components/Table/GreenOil/VesselTable.vue";
import TankerTable from "@/components/Table/GreenOil/TankerTable.vue";
import RefineryTable from "@/components/Table/GreenOil/RefineryTable.vue";
import DirectTree from "@/components/Charts/GreenOil/DirectedTree.vue";
import SunBurst from "@/components/Charts/SunBurstChart.vue";
import CardValue from "@/common/Card/CardValue";
import { formatNumber } from "@/utils/index";
import {
  OIL_TYPE,
  REFINERY_NAME,
  REFINERY_ID,
  TANKER_TYPE,
} from "../constant/index";
import _ from "lodash";

export default {
  name: "home",
  components: {
    Map,
    BarValue,
    StackedColumnChart,
    HighlightingChart,
    HighlightingChartTransfer,
    RadarBar,
    TransferTable,
    TankerTable,
    RefineryTable,
    DirectTree,
    SunBurst,
    OilTypeCard,
    CardValue,
    VesselTable,
  },
  data() {
    return {
      REFINERY_NAME,
      REFINERY_ID,
      TANKER_TYPE,
      formatNumber,
      selectedDate: {
        start: new Date(),
        end: new Date(),
      },
      config: {
        startDate: moment().format("DD/MM/YYYY"),
        endDate: moment().format("DD/MM/YYYY"),
        destination_type: "transit",
        isDomestic: "false",
      },
      barValueData: [0, 0, 0, 0],
      popupDirectTree: false,
      popupChart: false,
      popupTable: false,
    };
  },
  mounted() {
    this.$store.dispatch("activeOilCard", OIL_TYPE.GREEN_DIESEL);
    this.$store.dispatch("getTransferLogs");
    this.$store.dispatch("getLastOilPrice");
    this.$store.dispatch("getMpTransferLogsAll", this.config);
    this.$store.dispatch("getMpTankerAll");
    this.getVesselData();
  },
  watch: {
    selectedDate(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        let newStartDate = this.setDateFormat(newValue.start);
        let newEndDate = this.setDateFormat(newValue.end);
        this.config.startDate = newStartDate;
        this.config.endDate = newEndDate;
        this.$store.dispatch("getMpTransferLogsAll", this.config);
        this.getVesselData();
      }
    },
    currentRefID(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        let newStartDate = this.setDateFormat(this.selectedDate.start);
        let newEndDate = this.setDateFormat(this.selectedDate.end);
        this.config.startDate = newStartDate;
        this.config.endDate = newEndDate;
        this.config.station_id = this.currentRefID;
        this.$store.dispatch("getMpTransferLogsAll", this.config);
      }
    },
  },
  computed: {
    ...mapState({
      typeTanker: (state) => state.type,
      isAllCardActive: (state) => state.greenDieselCardActive.isAllCardActive,
      isIrpcCardActive: (state) => state.greenDieselCardActive.isIrpcCardActive,
      isSprcCardActive: (state) => state.greenDieselCardActive.isSprcCardActive,
      isTopCardActive: (state) => state.greenDieselCardActive.isTopCardActive,
      isBcpCardActive: (state) => state.greenDieselCardActive.isBcpCardActive,
      isPttgcCardActive: (state) =>
        state.greenDieselCardActive.isPttgcCardActive,
      isEssoCardActive: (state) => state.greenDieselCardActive.isEssoCardActive,
      currentRefID: (state) => state.vesselTrip.currentRefineryID,
      vesselTrip: (state) => state.vesselTrip.data,
      currentRefName: (state) => state.vesselTrip.currentRefineryName,
      isVesselTripLoading: (state) => state.vesselTrip.loading,
      lastOilPrice: (state) => state.oilPrice.lastOilPrice,
    }),
    ...mapGetters({
      getStationValues: "getStationValues",
      getStationData: "getStationData",
    }),
  },
  methods: {
    setDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    setFormat(date) {
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const newDate = moment(date)
          .add(543, "years")
          .format("DD/MM/YYYY");
        return newDate;
      } else {
        const newDate = moment(date).format("DD/MM/YYYY");
        return newDate;
      }
    },
    setRefineryCard(refineryName, refineryID) {
      let newStartDate = this.setDateFormat(this.selectedDate.start);
      let newEndDate = this.setDateFormat(this.selectedDate.end);
      this.config.startDate = newStartDate;
      this.config.endDate = newEndDate;
      this.config.station_id = refineryID;
      this.getVesselData();
      this.$store.dispatch("activeRefineryCard", refineryName);
      // this.$store.dispatch("setRadar", refineryName);
      this.$store.dispatch("setCurrentRefName", refineryName);
      this.$store.dispatch("setCurrentRefID", refineryID);

      if (refineryName == REFINERY_NAME.ALL) {
        this.$store.dispatch("setType", "oil");
      } else {
        this.$store.dispatch("setType", "tanker");
        this.$store.dispatch("setTankerName", refineryName);
      }
    },
    getVolume(key) {
      const stationId = REFINERY_ID[key];
      const volume = formatNumber(this.getStationValues(stationId));
      return volume;
    },
    async getVesselData() {
      this.$vs.loading({});
      await this.$store.dispatch("getVesselTrip", this.config);
      await this.$store.dispatch("getVesselVolume", this.config);
      await this.$store.dispatch("getMpTransferLogsAll", this.config);
      this.$vs.loading.close();
    },
    updateBarValue(value) {
      this.barValueData = value;
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
  calculateBarValue(value) {
    const valuewithout = value * 6.44;
    const value1Percent = valuewithout * 0.01;
    return [value, valuewithout, value, value1Percent];
  },
};
</script>

<style lang="scss">
#home {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
#barChartdiv {
  position: absolute;
  top: 0px;
  left: 0px;
  margin: 8px;
}
#nopad {
  padding: 0 !important;
}
.chart {
  // width: 120%;
  height: 365px;
  font-family: "Prompt", sans-serif;
}
.hello2 {
  height: 500px;
}
.center {
  // width: 200px;
  margin: auto;
}
.red {
  background-color: red;
}
.green {
  background-color: green;
}
@keyframes stretch {
  from {
    transform: rotate(0deg) translateX(15px) rotate(0deg);
  }
  to {
    transform: rotate(360deg) translateX(15px) rotate(-360deg);
  }
}

/* The element to apply the animation to */
.Animatio {
  position: relative;
  animation-duration: 10s;
  animation: stretch 2s ease-out 0s infinite none running;
}
.setHeight {
  height: 100%;
}
.fullScreenButton {
  position: absolute;
  right: 0px;
  top: 0px;
}
.cardDate {
  height: 62px;
}
.boldText {
  font-weight: bold;
}
.active {
  background-color: #cccccc;
}
.green {
  background-color: red;
}
.lighten-1 {
  background-color: red;
}
.v-btn .v-btn--active {
  background-color: red;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: red;
}
</style>
